// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-432feb2f] .v-dialog--fullscreen{margin:100px 0 0}", ""]);
// Exports
module.exports = exports;
